import authAxios from '@/utils/authaxios.util';
import ServiceHandler from '@/utils/servicehandler.util';
import appconfigService from '../appconfig/appconfig.service';
import ServiceConfig from '@/config/services.config';
import { ProductGroup } from '@/models/menu/productgroup.model';
import Product from '@/models/menu/product.model';
import ProductDivisionResponse from '@/models/responses/productdivision.response';
import ProductSingleResponse from '@/models/responses/product.response';
import { CartConfigInfo } from '@/store/modules/cart.module';
import store from '@/store';
import { Nullable } from '@/utils/customtypes.util';
import { ProductFavoriteResponse } from '@/models/responses/product-favorite.response';

class ProductService {
  public async getDivisionProducts(id: number): Promise<ProductGroup[]> {
    try {
      const appConfig = await appconfigService.get();
      const serviceUrl = appConfig.getServiceUrl(
        ServiceConfig.PRODUCT_DIVISION_LIST
      );
      const config = store.getters.currentConfig as Nullable<CartConfigInfo>;

      const resp = await authAxios
        .post(serviceUrl, {
          Data: {
            Menu: {
              MenuId: id,
            },
            BranchId: config?.BranchId,
            OrderIsPickUp: config?.OrderIsPickUp,
            OrderIsDineIn: config?.OrderIsDineIn,
            OrderIsKiosk: config?.OrderIsKiosk,
            GetOnlineProductsOnly: true,
          },
        })
        .then(
          ServiceHandler.checkSuccess<ProductDivisionResponse>(
            ProductDivisionResponse
          )
        )
        .catch(ServiceHandler.catchError());

      const result = resp.MenuProducts ?? [];
      return Promise.resolve(result);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getProduct(id: number): Promise<Product> {
    try {
      const appConfig = await appconfigService.get();
      const serviceUrl = appConfig.getServiceUrl(ServiceConfig.PRODUCT_GET);
      const config = store.getters.currentConfig as Nullable<CartConfigInfo>;

      const resp = await authAxios
        .post(serviceUrl, {
          Data: {
            ProductId: id,
            BranchId: config?.BranchId,
            OrderIsPickUp: config?.OrderIsPickUp,
            OrderIsDineIn: config?.OrderIsDineIn,
            OrderIsKiosk: config?.OrderIsKiosk,
          },
        })
        .then(
          ServiceHandler.checkSuccess<ProductSingleResponse>(
            ProductSingleResponse
          )
        )
        .catch(ServiceHandler.catchError());

      const result = resp.MenuProduct ?? ({} as Product);
      return Promise.resolve(result);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getFavorites(clientId: number): Promise<Product[]> {
    try {
      const appConfig = await appconfigService.get();
      const serviceUrl = appConfig.getServiceUrl(
        ServiceConfig.PRODUCT_FAVORITE
      );
      const config = store.getters.currentConfig as Nullable<CartConfigInfo>;

      const resp = await authAxios
        .post(serviceUrl, {
          Data: {
            ClientId: clientId,
            BranchId: config?.BranchId,
            OrderIsPickUp: config?.OrderIsPickUp,
            OrderIsDineIn: config?.OrderIsDineIn,
            OrderIsKiosk: config?.OrderIsKiosk,
            GetOnlineProductsOnly: true,
            IncludeBestSeller: true,
          },
        })
        .then(
          ServiceHandler.checkSuccess<ProductFavoriteResponse>(
            ProductFavoriteResponse
          )
        )
        .catch(ServiceHandler.catchError());

      const result = resp.FavoriteProductList ?? [];
      return Promise.resolve(result);
    } catch (err) {
      return Promise.reject(err);
    }
  }
}

export default new ProductService();
